<template>
    <div class="scientific-article">
        <a id="viber_share" style="display: none;" href=""></a>

        <product-popup @closePopup="closePopup()" :productInfo="productInfo" v-if="isProductInfoOpen" />
        <language-popup @closePopup="closePopup()" :action="action" :contentUa="articleItem.contentUa" :contentRu="articleItem.contentRu" :contentEn="articleItem.contentEn" v-if="action" />

        <div class="article-header">
            <div class="article-type">Методичні рекомендації</div>
            <div class="language" v-if="getLangCount() > 1">
                <div class="ukr" v-if="articleItem.contentUa">УКР</div>
                <div class="delimetr" v-if="articleItem.contentEn">|</div>
                <div class="en" v-if="articleItem.contentEn">EN</div>
                <div class="delimetr" v-if="articleItem.contentRu">|</div>
                <div class="ru" v-if="articleItem.contentRu">РУС</div>
            </div>
        </div>

        <div class="article-content">

            <div class="article-title">
                <div class="image">
                    <svg width="59" height="90" viewBox="0 0 59 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 7.61405C0.5 7.37994 0.673463 7.18206 0.905562 7.15141L50.2056 0.640086C50.4851 0.603161 50.7333 0.82073 50.7333 1.10273V82.2859C50.7333 82.5201 50.5599 82.7179 50.3278 82.7486L1.02777 89.2599C0.748195 89.2968 0.5 89.0793 0.5 88.7973V7.61405Z" fill="#B2CADA" stroke="#9AB9D8"/>
                        <path d="M0.5 7.66883C0.5 7.42358 0.689828 7.22018 0.934491 7.20327L53.4885 3.5711C53.7605 3.5523 53.9906 3.76969 53.9873 4.04231L53.0107 84.6143C53.0078 84.8551 52.8222 85.0541 52.5823 85.0738L1.00491 89.3157C0.733016 89.338 0.5 89.1234 0.5 88.8506V7.66883Z" fill="#C5DEEF" stroke="#9AB9D8"/>
                        <mask id="path-3-inside-1" fill="white">
                        <rect y="6.7666" width="58" height="83.1333" rx="0.966667"/>
                        </mask>
                        <rect y="6.7666" width="58" height="83.1333" rx="0.966667" fill="#E4F5FF" stroke="#9AB9D8" stroke-width="2" mask="url(#path-3-inside-1)"/>
                        <path opacity="0.7" d="M9.69385 37.9L8.83447 35.0997H8.8125C8.84342 35.6694 8.85889 36.0494 8.85889 36.2399V37.9H8.18262V34.3307H9.21289L10.0576 37.0602H10.0723L10.9683 34.3307H11.9985V37.9H11.293V36.2106C11.293 36.1308 11.2938 36.0389 11.2954 35.9347C11.2987 35.8305 11.3101 35.5538 11.3296 35.1046H11.3076L10.3872 37.9H9.69385ZM14.9551 37.9H12.8994V34.3307H14.9551V34.9508H13.6562V35.7345H14.8647V36.3546H13.6562V37.275H14.9551V37.9ZM17.0791 37.9H16.3223V34.9606H15.353V34.3307H18.0483V34.9606H17.0791V37.9ZM21.8374 36.1105C21.8374 36.7013 21.6909 37.1554 21.3979 37.4728C21.105 37.7902 20.6851 37.9489 20.1382 37.9489C19.5913 37.9489 19.1714 37.7902 18.8784 37.4728C18.5854 37.1554 18.439 36.6997 18.439 36.1056C18.439 35.5115 18.5854 35.0582 18.8784 34.7457C19.173 34.4316 19.5946 34.2745 20.1431 34.2745C20.6916 34.2745 21.1107 34.4324 21.4004 34.7482C21.6917 35.0639 21.8374 35.518 21.8374 36.1105ZM19.2324 36.1105C19.2324 36.5092 19.3081 36.8095 19.4595 37.0114C19.6108 37.2132 19.8371 37.3141 20.1382 37.3141C20.742 37.3141 21.0439 36.9129 21.0439 36.1105C21.0439 35.3064 20.7437 34.9044 20.1431 34.9044C19.842 34.9044 19.6149 35.0061 19.4619 35.2096C19.3089 35.4114 19.2324 35.7117 19.2324 36.1105ZM22.1523 37.2701H22.4282C22.6642 36.7981 22.8506 36.3269 22.9873 35.8566C23.124 35.3846 23.2257 34.8759 23.2925 34.3307H25.3726V37.2701H25.8486V38.9401H25.1187V37.9H22.8823V38.9401H22.1523V37.2701ZM23.8931 34.9606C23.841 35.3333 23.7539 35.728 23.6318 36.1447C23.5114 36.5613 23.3755 36.9365 23.2241 37.2701H24.6182V34.9606H23.8931ZM26.4004 34.3307H27.0815V36.0543L27.0718 36.5157L27.0474 37.0406H27.062L28.71 34.3307H29.6157V37.9H28.9419V36.1862C28.9419 35.9567 28.9565 35.6165 28.9858 35.1656H28.9663L27.311 37.9H26.4004V34.3307ZM33.2583 37.9H32.5015V36.5206C32.2508 36.6053 32.0417 36.663 31.874 36.694C31.708 36.7249 31.5493 36.7404 31.3979 36.7404C31.0578 36.7404 30.7949 36.659 30.6094 36.4962C30.4255 36.3318 30.3335 36.1015 30.3335 35.8053V34.3307H31.0879V35.5905C31.0879 35.763 31.1278 35.8932 31.2075 35.9811C31.2873 36.0673 31.4224 36.1105 31.6128 36.1105C31.7463 36.1105 31.8789 36.0975 32.0107 36.0714C32.1442 36.0437 32.3078 35.9965 32.5015 35.9298V34.3307H33.2583V37.9ZM37.084 37.9H36.3296V36.3595H34.916V37.9H34.1592V34.3307H34.916V35.7296H36.3296V34.3307H37.084V37.9ZM37.9873 37.9V34.3307H38.7441V37.9H37.9873ZM8.93945 43.0104H9.18848C9.42122 43.0104 9.59538 42.9648 9.71094 42.8737C9.8265 42.7809 9.88428 42.6466 9.88428 42.4708C9.88428 42.2934 9.83545 42.1624 9.73779 42.0778C9.64176 41.9931 9.4904 41.9508 9.28369 41.9508H8.93945V43.0104ZM10.6484 42.444C10.6484 42.8281 10.528 43.1219 10.2871 43.3253C10.0479 43.5288 9.70687 43.6305 9.26416 43.6305H8.93945V44.9H8.18262V41.3307H9.32275C9.7557 41.3307 10.0845 41.4243 10.3091 41.6115C10.5353 41.797 10.6484 42.0745 10.6484 42.444ZM13.3779 44.9H11.3223V41.3307H13.3779V41.9508H12.0791V42.7345H13.2876V43.3546H12.0791V44.275H13.3779V44.9ZM17.0352 44.9H16.1758L14.8818 43.0909V44.9H14.125V41.3307H14.8818V43.0592L16.1611 41.3307H16.9668L15.6655 43.0446L17.0352 44.9ZM20.7241 43.1105C20.7241 43.7013 20.5776 44.1554 20.2847 44.4728C19.9917 44.7902 19.5718 44.9489 19.0249 44.9489C18.478 44.9489 18.0581 44.7902 17.7651 44.4728C17.4722 44.1554 17.3257 43.6997 17.3257 43.1056C17.3257 42.5115 17.4722 42.0582 17.7651 41.7457C18.0597 41.4316 18.4813 41.2745 19.0298 41.2745C19.5783 41.2745 19.9974 41.4324 20.2871 41.7482C20.5785 42.0639 20.7241 42.518 20.7241 43.1105ZM18.1191 43.1105C18.1191 43.5092 18.1948 43.8095 18.3462 44.0114C18.4976 44.2132 18.7238 44.3141 19.0249 44.3141C19.6287 44.3141 19.9307 43.9129 19.9307 43.1105C19.9307 42.3064 19.6304 41.9044 19.0298 41.9044C18.7287 41.9044 18.5016 42.0061 18.3486 42.2096C18.1956 42.4114 18.1191 42.7117 18.1191 43.1105ZM22.9751 44.9L22.1157 42.0997H22.0938C22.1247 42.6694 22.1401 43.0494 22.1401 43.2399V44.9H21.4639V41.3307H22.4941L23.3389 44.0602H23.3535L24.2495 41.3307H25.2798V44.9H24.5742V43.2106C24.5742 43.1308 24.575 43.0389 24.5767 42.9347C24.5799 42.8305 24.5913 42.5538 24.6108 42.1046H24.5889L23.6685 44.9H22.9751ZM28.2363 44.9H26.1807V41.3307H28.2363V41.9508H26.9375V42.7345H28.146V43.3546H26.9375V44.275H28.2363V44.9ZM31.9082 44.9H31.1538V43.3595H29.7402V44.9H28.9834V41.3307H29.7402V42.7296H31.1538V41.3307H31.9082V44.9ZM32.3867 44.2701H32.6626C32.8986 43.7981 33.085 43.3269 33.2217 42.8566C33.3584 42.3846 33.4601 41.8759 33.5269 41.3307H35.6069V44.2701H36.083V45.9401H35.353V44.9H33.1167V45.9401H32.3867V44.2701ZM34.1274 41.9606C34.0754 42.3333 33.9883 42.728 33.8662 43.1447C33.7458 43.5613 33.6099 43.9365 33.4585 44.2701H34.8525V41.9606H34.1274ZM38.8198 44.9L38.561 44.0504H37.2598L37.001 44.9H36.1855L37.4453 41.316H38.3706L39.6353 44.9H38.8198ZM38.3804 43.4156C38.1411 42.6458 38.006 42.2104 37.9751 42.1095C37.9458 42.0086 37.9246 41.9288 37.9116 41.8702C37.8579 42.0786 37.7041 42.5937 37.4502 43.4156H38.3804ZM42.9116 44.2994H43.4438V45.9401H42.7139V44.9H40.0869V41.3307H40.8438V44.2701H42.1572V41.3307H42.9116V44.2994ZM43.9932 44.9V41.3307H44.75V44.9H43.9932ZM45.6484 44.9V41.3307H46.4053V44.9H45.6484ZM45.1919 40.6447C45.1919 40.5389 45.222 40.4575 45.2822 40.4005C45.3441 40.3435 45.4271 40.3151 45.5312 40.3151C45.6387 40.3151 45.7225 40.3452 45.7827 40.4054C45.8446 40.4656 45.8755 40.5454 45.8755 40.6447C45.8755 40.7423 45.8446 40.8212 45.7827 40.8815C45.7209 40.9401 45.637 40.9694 45.5312 40.9694C45.4271 40.9694 45.3441 40.9409 45.2822 40.8839C45.222 40.8269 45.1919 40.7472 45.1919 40.6447ZM46.1758 40.6447C46.1758 40.5307 46.2083 40.4477 46.2734 40.3956C46.3402 40.3419 46.4224 40.3151 46.52 40.3151C46.6258 40.3151 46.7096 40.3444 46.7715 40.403C46.835 40.4615 46.8667 40.5421 46.8667 40.6447C46.8667 40.7439 46.835 40.8229 46.7715 40.8815C46.708 40.9401 46.6242 40.9694 46.52 40.9694C46.4224 40.9694 46.3402 40.9433 46.2734 40.8912C46.2083 40.8375 46.1758 40.7553 46.1758 40.6447Z" fill="#1E3B89"/>
                        <path opacity="0.7" d="M10.6663 56.9429C13.3085 67.6576 30.4829 73.4667 30.4829 73.4667C30.4829 73.4667 47.217 68.1044 50.2996 56.9429C50.7829 54.1333 50.783 33.7406 50.2996 30C48.9996 29 44.4996 26.1 38.2373 26.1" stroke="#1E3B89" stroke-width="1.3" stroke-linecap="round"/>
                    </svg>
                </div>
                <div class="title">
                    {{articleItem.title}}
                </div>
            </div>

            <div class="moz-section">
                <div class="row">
                    <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.4536 1L6.44238 9.53646" stroke="#00ACE6" stroke-width="0.69154" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M6.44307 9.53638C6.44307 9.53638 4.00684 11.0868 4.00684 14.0093C4.00684 15.4489 6.44583 16.9999 6.44583 16.9999C6.44583 16.9999 8.88482 15.4495 8.88482 14.0093C8.88482 11.0874 6.44307 9.53638 6.44307 9.53638Z" stroke="#00ACE6" stroke-width="0.69154" stroke-miterlimit="10"/>
                        <path d="M1.18555 10.7119L6.44501 12.4759L11.7038 10.7119" stroke="#00ACE6" stroke-width="0.69154" stroke-miterlimit="10"/>
                        <path d="M11.7042 10.712L8.97389 8.92278C8.97389 8.92278 9.01038 5.15728 11.8908 2.32861V13.9583H1V2.32861C3.88038 5.15728 3.91618 8.92278 3.91618 8.92278L1.18592 10.712" stroke="#00ACE6" stroke-width="0.69154" stroke-miterlimit="10"/>
                        <path d="M6.44531 12.476V16.9999" stroke="#00ACE6" stroke-width="0.69154" stroke-miterlimit="10"/>
                    </svg>
                    МОЗ України
                </div>
                <div class="row">
                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.45 4.97982V14.4588H1.55V4.97982H13.45ZM13.75 1.93246H12.55V1.24561C12.55 1.08134 12.415 0.95 12.25 0.95H10.5C10.335 0.95 10.2 1.08134 10.2 1.24561V1.93246H4.8V1.24561C4.8 1.08134 4.66503 0.95 4.5 0.95H2.75C2.58497 0.95 2.45 1.08134 2.45 1.24561V1.93246H1.25C1.08497 1.93246 0.95 2.0638 0.95 2.22807V4.68421V15V15.05H1H1.00001H1.00002H1.00003H1.00005H1.00006H1.00008H1.0001H1.00013H1.00015H1.00018H1.00021H1.00025H1.00029H1.00032H1.00037H1.00041H1.00046H1.00051H1.00056H1.00061H1.00067H1.00073H1.00079H1.00085H1.00092H1.00099H1.00106H1.00113H1.00121H1.00129H1.00137H1.00145H1.00154H1.00163H1.00172H1.00181H1.00191H1.00201H1.00211H1.00221H1.00231H1.00242H1.00253H1.00264H1.00276H1.00288H1.003H1.00312H1.00324H1.00337H1.0035H1.00363H1.00376H1.0039H1.00404H1.00418H1.00432H1.00447H1.00461H1.00476H1.00492H1.00507H1.00523H1.00539H1.00555H1.00571H1.00588H1.00605H1.00622H1.00639H1.00657H1.00675H1.00693H1.00711H1.00729H1.00748H1.00767H1.00786H1.00805H1.00825H1.00845H1.00865H1.00885H1.00905H1.00926H1.00947H1.00968H1.0099H1.01011H1.01033H1.01055H1.01077H1.011H1.01122H1.01145H1.01168H1.01192H1.01215H1.01239H1.01263H1.01287H1.01312H1.01336H1.01361H1.01386H1.01412H1.01437H1.01463H1.01489H1.01515H1.01541H1.01568H1.01595H1.01622H1.01649H1.01676H1.01704H1.01732H1.0176H1.01788H1.01817H1.01845H1.01874H1.01903H1.01933H1.01962H1.01992H1.02022H1.02052H1.02082H1.02113H1.02144H1.02174H1.02206H1.02237H1.02269H1.023H1.02332H1.02364H1.02397H1.02429H1.02462H1.02495H1.02528H1.02562H1.02595H1.02629H1.02663H1.02697H1.02732H1.02766H1.02801H1.02836H1.02871H1.02907H1.02942H1.02978H1.03014H1.0305H1.03086H1.03123H1.0316H1.03196H1.03234H1.03271H1.03308H1.03346H1.03384H1.03422H1.0346H1.03499H1.03537H1.03576H1.03615H1.03654H1.03694H1.03733H1.03773H1.03813H1.03853H1.03894H1.03934H1.03975H1.04016H1.04057H1.04098H1.04139H1.04181H1.04223H1.04265H1.04307H1.04349H1.04392H1.04435H1.04478H1.04521H1.04564H1.04607H1.04651H1.04695H1.04739H1.04783H1.04827H1.04872H1.04916H1.04961H1.05006H1.05052H1.05097H1.05143H1.05188H1.05234H1.0528H1.05327H1.05373H1.0542H1.05466H1.05513H1.05561H1.05608H1.05655H1.05703H1.05751H1.05799H1.05847H1.05895H1.05944H1.05992H1.06041H1.0609H1.06139H1.06189H1.06238H1.06288H1.06338H1.06388H1.06438H1.06488H1.06539H1.06589H1.0664H1.06691H1.06742H1.06794H1.06845H1.06897H1.06949H1.07001H1.07053H1.07105H1.07157H1.0721H1.07263H1.07316H1.07369H1.07422H1.07475H1.07529H1.07583H1.07636H1.0769H1.07745H1.07799H1.07853H1.07908H1.07963H1.08018H1.08073H1.08128H1.08183H1.08239H1.08295H1.08351H1.08407H1.08463H1.08519H1.08575H1.08632H1.08689H1.08746H1.08803H1.0886H1.08917H1.08975H1.09032H1.0909H1.09148H1.09206H1.09264H1.09323H1.09381H1.0944H1.09499H1.09558H1.09617H1.09676H1.09735H1.09795H1.09855H1.09914H1.09974H1.10034H1.10095H1.10155H1.10215H1.10276H1.10337H1.10398H1.10459H1.1052H1.10581H1.10643H1.10704H1.10766H1.10828H1.1089H1.10952H1.11014H1.11077H1.11139H1.11202H1.11265H1.11328H1.11391H1.11454H1.11517H1.11581H1.11644H1.11708H1.11772H1.11836H1.119H1.11964H1.12029H1.12093H1.12158H1.12223H1.12287H1.12352H1.12418H1.12483H1.12548H1.12614H1.12679H1.12745H1.12811H1.12877H1.12943H1.13009H1.13076H1.13142H1.13209H1.13275H1.13342H1.13409H1.13476H1.13544H1.13611H1.13678H1.13746H1.13814H1.13881H1.13949H1.14017H1.14085H1.14154H1.14222H1.14291H1.14359H1.14428H1.14497H1.14566H1.14635H1.14704H1.14773H1.14843H1.14912H1.14982H1.15051H1.15121H1.15191H1.15261H1.15332H1.15402H1.15472H1.15543H1.15613H1.15684H1.15755H1.15826H1.15897H1.15968H1.16039H1.16111H1.16182H1.16254H1.16325H1.16397H1.16469H1.16541H1.16613H1.16685H1.16757H1.1683H1.16902H1.16975H1.17048H1.1712H1.17193H1.17266H1.17339H1.17412H1.17486H1.17559H1.17633H1.17706H1.1778H1.17854H1.17927H1.18001H1.18075H1.1815H1.18224H1.18298H1.18373H1.18447H1.18522H1.18596H1.18671H1.18746H1.18821H1.18896H1.18971H1.19047H1.19122H1.19197H1.19273H1.19349H1.19424H1.195H1.19576H1.19652H1.19728H1.19804H1.1988H1.19956H1.20033H1.20109H1.20186H1.20263H1.20339H1.20416H1.20493H1.2057H1.20647H1.20724H1.20801H1.20879H1.20956H1.21033H1.21111H1.21189H1.21266H1.21344H1.21422H1.215H1.21578H1.21656H1.21734H1.21812H1.21891H1.21969H1.22048H1.22126H1.22205H1.22283H1.22362H1.22441H1.2252H1.22599H1.22678H1.22757H1.22836H1.22915H1.22995H1.23074H1.23154H1.23233H1.23313H1.23393H1.23472H1.23552H1.23632H1.23712H1.23792H1.23872H1.23952H1.24032H1.24113H1.24193H1.24273H1.24354H1.24434H1.24515H1.24596H1.24676H1.24757H1.24838H1.24919H1.25L13.9151 15.05L13.9867 15.1304L13.9872 15.05H14.049L13.9876 14.9811L14.05 4.68451V4.68421V2.22807C14.05 2.0638 13.915 1.93246 13.75 1.93246ZM10.8 2.22807V1.54123H11.95V2.22807V2.91491H10.8V2.22807ZM3.05 2.22807V1.54123H4.2V2.22807V2.91491H3.05V2.22807ZM1.55 2.52368H2.45V3.21052C2.45 3.37479 2.58497 3.50614 2.75 3.50614H4.5C4.66503 3.50614 4.8 3.37479 4.8 3.21052V2.52368H10.2V3.21052C10.2 3.37479 10.335 3.50614 10.5 3.50614H12.25C12.415 3.50614 12.55 3.37479 12.55 3.21052V2.52368H13.45V4.38859H1.55V2.52368Z" fill="#00ACE6" stroke="#00ACE6" stroke-width="0.1"/>
                    </svg>
                    {{articleItem.publishYear}}
                </div>
            </div>

            <div class="points">
                <div class="anotation item" >

                    <div class="title" @click="isAnotationOpen = !isAnotationOpen">
                        <div class="text">
                            Анотація
                        </div>
                        <div class="open">
                            <div class="line" :class="isAnotationOpen ? '': 'rotated'"></div>
                            <div class="line"></div>
                        </div>
                    </div>

                    <transition name="fade">
                        <div class="container" v-if="isAnotationOpen">
                            {{articleItem.annotation}}
                        </div>
                    </transition>

                </div>

                <div class="key-words item" v-if="articleItem.tags.length > 0">

                    <div class="title" @click="isKeyWordsOpen = !isKeyWordsOpen">
                        <div class="text">
                            Ключові слова
                        </div>
                        <div class="open">
                            <div class="line" :class="isKeyWordsOpen ? '': 'rotated'"></div>
                            <div class="line"></div>
                        </div>
                    </div>

                    <transition name="fade">
                        <div class="container" v-if="isKeyWordsOpen">
                            <div v-for="(tag, index) in articleItem.tags" :key="index">
                                {{tag.title}}<span v-if="index !== articleItem.tags.length - 1">,&nbsp;</span>
                            </div>
                            <!-- <div v-for="(word, index) in getProductTags()" :key="index">
                                {{word.title}}<span v-if="index !== getProductTags().length - 1">,&nbsp;</span>
                            </div> -->
                        </div>
                    </transition>

                </div>

                <div class="products item" v-if="articleItem.products.length > 0">

                    <div class="title" @click="isProductsOpen = !isProductsOpen">
                        <div class="text">
                            Згадані продукти
                        </div>
                        <div class="open">
                            <div class="line" :class="isProductsOpen ? '': 'rotated'"></div>
                            <div class="line"></div>
                        </div>
                    </div>

                    <transition name="fade">
                        <div class="container" v-if="isProductsOpen">
                            <div class="product-label" v-for="(product, index) in articleItem.products" :key="index" @click="openProductInfoPopup(product)" >
                                {{product.title}}
                            </div>
                        </div>
                    </transition>

                </div>

                <div class="dev-algorithms item" v-if="articleItem.algorithms.length > 0">

                    <div class="title" @click="isAlgorithmsOpen = !isAlgorithmsOpen">
                        <div class="text">
                            Розроблені алгоритми
                        </div>
                        <div class="open">
                            <div class="line" :class="isAlgorithmsOpen ? '': 'rotated'"></div>
                            <div class="line"></div>
                        </div>
                    </div>

                    <transition name="fade">
                        <div class="container" v-if="isAlgorithmsOpen">
                            <div v-for="(algorithm, index) in articleItem.algorithms" :key="index" class="algorithm">
                                <div class="icon">
                                    <img :src="$root.globalUrl + algorithm.icon.name" alt="" width="24">
                                </div>
                                <div class="name">{{algorithm.title}}</div>
                                <router-link class="go" :to="getRef(algorithm.link)" tag="a">
                                    перейти
                                </router-link>
                            </div>
                        </div>
                    </transition>

                </div>
            </div>

            <div class="actions-block">
                <div class="read-send">
                    <div class="read" @click="openLanguagePopup('read')">
                        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.08079 15.8384L3.07161 11.7677H10.1257C11.152 11.7677 11.9869 10.9329 11.9869 9.90656V8.48851C11.9869 8.48706 11.9869 8.48562 11.9868 8.48418V7.27586C11.9868 6.24951 11.152 5.41468 10.1257 5.41468H3.04891V2.39354C3.04891 1.92362 3.43126 1.54119 3.90097 1.54119H4.11173H4.1707H8.60191C9.52645 1.54119 12.7626 1.54125 13.229 1.5704C13.8696 1.61044 14.3884 2.09218 14.3884 2.77613C14.3884 3.14477 14.388 3.47016 14.3876 3.77718C14.387 4.34197 14.3864 4.84458 14.3884 5.43982C14.3884 5.43992 14.3884 5.44001 14.3884 5.44011L14.3884 15.6065C14.3884 16.0764 14.006 16.4588 13.5363 16.4588H3.90103C3.51606 16.4588 3.18379 16.2055 3.08079 15.8384ZM11.3457 8.5473C11.3457 8.54874 11.3457 8.55019 11.3457 8.55163V9.90656C11.3457 10.5792 10.7983 11.1266 10.1257 11.1266H2.2182C1.84499 11.1266 1.54118 10.8227 1.54118 10.4495V5.86832C1.73914 5.9873 1.97084 6.05586 2.2182 6.05586H10.1257C10.7983 6.05586 11.3457 6.60323 11.3457 7.27586V8.5473ZM2.40776 3.41945H2.2182C1.49124 3.41945 0.9 4.01072 0.9 4.73766V10.4495C0.9 11.1765 1.49124 11.7677 2.2182 11.7677H2.43037L2.43979 15.8818L2.4398 15.8822C2.43997 15.9066 2.44292 15.9308 2.44855 15.9544L2.44856 15.9545C2.60968 16.6288 3.20722 17.1 3.901 17.1H13.5363C14.3598 17.1 15.0295 16.4301 15.0295 15.6065L15.0296 4.9493V4.94369V4.93809V4.93251V4.92694V4.92138V4.91583V4.9103V4.90478V4.89927V4.89378V4.8883V4.88283V4.87737V4.87193V4.8665V4.86108V4.85568V4.85029V4.8449V4.83954V4.83418V4.82884V4.82351V4.81819V4.81288V4.80759V4.8023V4.79703V4.79177V4.78653V4.78129V4.77607V4.77086V4.76566V4.76047V4.75529V4.75013V4.74498V4.73984V4.73471V4.72959V4.72448V4.71938V4.7143V4.70923V4.70416V4.69911V4.69407V4.68904V4.68402V4.67902V4.67402V4.66904V4.66406V4.6591V4.65414V4.6492V4.64427V4.63935V4.63444V4.62954V4.62465V4.61977V4.6149V4.61004V4.60519V4.60035V4.59553V4.59071V4.5859V4.5811V4.57631V4.57154V4.56677V4.56201V4.55726V4.55252V4.54779V4.54307V4.53836V4.53366V4.52897V4.52429V4.51962V4.51496V4.5103V4.50566V4.50102V4.4964V4.49178V4.48718V4.48258V4.47799V4.47341V4.46884V4.46427V4.45972V4.45518V4.45064V4.44611V4.44159V4.43708V4.43258V4.42809V4.4236V4.41913V4.41466V4.4102V4.40575V4.4013V4.39687V4.39244V4.38802V4.38361V4.37921V4.37482V4.37043V4.36605V4.36168V4.35731V4.35296V4.34861V4.34427V4.33994V4.33561V4.33129V4.32698V4.32268V4.31838V4.3141V4.30981V4.30554V4.30127V4.29701V4.29276V4.28851V4.28428V4.28004V4.27582V4.2716V4.26739V4.26318V4.25899V4.25479V4.25061V4.24643V4.24226V4.2381V4.23394V4.22978V4.22564V4.2215V4.21736V4.21324V4.20912V4.205V4.20089V4.19679V4.19269V4.1886V4.18451V4.18043V4.17636V4.17229V4.16823V4.16417V4.16012V4.15608V4.15204V4.148V4.14397V4.13995V4.13593V4.13191V4.12791V4.1239V4.1199V4.11591V4.11192V4.10794V4.10396V4.09999V4.09602V4.09206V4.0881V4.08415V4.0802V4.07625V4.07231V4.06838V4.06444V4.06052V4.05659V4.05268V4.04876V4.04485V4.04095V4.03705V4.03315V4.02926V4.02537V4.02148V4.0176V4.01372V4.00985V4.00598V4.00211V3.99825V3.99439V3.99054V3.98669V3.98284V3.97899V3.97515V3.97131V3.96748V3.96365V3.95982V3.956V3.95217V3.94836V3.94454V3.94073V3.93692V3.93311V3.92931V3.92551V3.92171V3.91791V3.91412V3.91033V3.90654V3.90276V3.89897V3.89519V3.89141V3.88764V3.88387V3.88009V3.87633V3.87256V3.86879V3.86503V3.86127V3.85751V3.85376V3.85V3.84625V3.8425V3.83875V3.835V3.83125V3.82751V3.82377V3.82002V3.81628V3.81255V3.80881V3.80507V3.80134V3.79761V3.79387V3.79014V3.78641V3.78268V3.77896V3.77523V3.7715V3.76778V3.76405V3.76033V3.75661V3.75289V3.74916V3.74544V3.74172V3.738V3.73428V3.73056V3.72685V3.72313V3.71941V3.71569V3.71197V3.70826V3.70454V3.70082V3.6971V3.69339V3.68967V3.68595V3.68223V3.67851V3.6748V3.67108V3.66736V3.66364V3.65992V3.6562V3.65247V3.64875V3.64503V3.64131V3.63758V3.63386V3.63013V3.62641V3.62268V3.61895V3.61522V3.61149V3.60776V3.60402V3.60029V3.59655V3.59282V3.58908V3.58534V3.5816V3.57786V3.57411V3.57037V3.56662V3.56287V3.55912V3.55537V3.55161V3.54786V3.5441V3.54034V3.53658V3.53281V3.52905V3.52528V3.52151V3.51774V3.51396V3.51018V3.5064V3.50262V3.49884V3.49505V3.49126V3.48747V3.48367V3.47987V3.47607V3.47227V3.46847V3.46466V3.46084V3.45703V3.45321V3.44939V3.44557V3.44174V3.43791V3.43408V3.43024V3.4264V3.42255V3.41871V3.41486V3.411V3.40714V3.40328V3.39942V3.39555V3.39168V3.3878V3.38392V3.38004V3.37615V3.37226V3.36836V3.36446V3.36056V3.35665V3.35273V3.34882V3.3449V3.34097V3.33704V3.33311V3.32917V3.32522V3.32128V3.31732V3.31336V3.3094V3.30544V3.30146V3.29749V3.29351V3.28952V3.28553V3.28153V3.27753V3.27352V3.26951V3.26549V3.26147V3.25744V3.25341V3.24937V3.24532V3.24128V3.23722V3.23316V3.22909V3.22502V3.22094V3.21686V3.21277V3.20867V3.20457V3.20046V3.19635V3.19223V3.1881V3.18397V3.17983V3.17569V3.17154V3.16738V3.16322V3.15905V3.15487V3.15069V3.1465V3.1423V3.1381V3.13389V3.12967V3.12545V3.12122V3.11698V3.11274V3.10849V3.10423V3.09996V3.09569V3.09141V3.08713V3.08283V3.07853V3.07422V3.06991V3.06558V3.06125V3.05691V3.05257V3.04821V3.04385V3.03948V3.03511V3.03072V3.02633V3.02193V3.01752V3.0131V3.00868V3.00424V2.9998V2.99535V2.9909V2.98643V2.98196V2.97747V2.97298V2.96848V2.96398V2.95946V2.95493V2.9504V2.94586V2.94131V2.93675V2.93218V2.9276V2.92301V2.91842V2.91381V2.9092V2.90457V2.89994V2.8953V2.89065V2.88599V2.88132V2.87664V2.87195V2.86726V2.86255V2.85783V2.85311V2.84837V2.84362V2.83887V2.8341V2.82933V2.82454V2.81975V2.81494V2.81012V2.8053V2.80046V2.79562V2.79076V2.7859V2.78102V2.77613C15.0296 1.90305 14.4136 0.900037 13.2353 0.900011H9.09805H4.1707H4.11173H3.901C3.07751 0.900011 2.40776 1.56995 2.40776 2.39354V3.41945ZM2.2182 4.06063H2.40776V5.41468H2.2182C1.84499 5.41468 1.54118 5.11087 1.54118 4.73766C1.54118 4.36444 1.84497 4.06063 2.2182 4.06063Z" fill="#00ACE6" stroke="#00ACE6" stroke-width="0.2"/>
                            <path d="M9.87948 7.42956C9.99206 7.42956 10.0833 7.33832 10.0833 7.22577C10.0833 7.11322 9.99206 7.02197 9.87948 7.02197H8.8288C8.71622 7.02197 8.625 7.11322 8.625 7.22577V9.81818C8.625 9.93073 8.71622 10.022 8.8288 10.022C8.94137 10.022 9.03259 9.93073 9.03259 9.81818V8.70122H9.79603C9.90861 8.70122 9.99983 8.60997 9.99983 8.49742C9.99983 8.38487 9.90861 8.29363 9.79603 8.29363H9.03259V7.42956H9.87948Z" fill="#00ACE6"/>
                            <path d="M5.75604 7.02197C5.70194 7.02197 5.65004 7.04349 5.61178 7.08181C5.57358 7.12012 5.55214 7.17205 5.55225 7.22617V7.2284V7.22848V9.77609C5.55225 9.79196 5.55423 9.80734 5.55768 9.82214C5.55871 9.87502 5.58015 9.92551 5.61771 9.96282C5.65588 10.0007 5.70751 10.022 5.76129 10.022H5.76205C5.78419 10.0219 6.30694 10.0199 6.5153 10.0162C6.87697 10.0099 7.19897 9.84608 7.42208 9.55493C7.62767 9.28657 7.74092 8.91974 7.74092 8.52199C7.74092 7.6248 7.23831 7.022 6.49025 7.022H5.75604V7.02197ZM7.33333 8.52199C7.33333 9.15334 6.99403 9.60022 6.50818 9.6087C6.38425 9.61088 6.14002 9.61248 5.96437 9.61343C5.96337 9.31608 5.96168 8.77176 5.96168 8.51913C5.96168 8.3077 5.96073 7.73765 5.96016 7.42959H6.49022C6.89784 7.42956 7.33333 7.71656 7.33333 8.52199Z" fill="#00ACE6"/>
                            <path d="M3.20253 7.00003C3.14872 7.00003 3.09712 7.02144 3.0591 7.05956C3.02136 7.09742 3.00019 7.14866 3.00005 7.2021C3.00005 7.20226 3 7.2024 3 7.20253V9.7975C3 9.90933 3.09064 10 3.2025 10C3.31437 10 3.40501 9.90933 3.40501 9.7975V8.8717C3.57306 8.87078 3.80615 8.86962 3.92506 8.86962C4.44842 8.86962 4.87419 8.45028 4.87419 7.93481C4.87419 7.41935 4.44839 7 3.92506 7H3.20253V7.00003ZM4.46921 7.93484C4.46921 8.22202 4.22002 8.46464 3.92509 8.46464C3.80683 8.46464 3.57697 8.46578 3.40892 8.4667C3.408 8.29413 3.40684 8.0555 3.40684 7.93484C3.40684 7.83305 3.4062 7.58451 3.40566 7.40503H3.92509C4.22002 7.40503 4.46921 7.64763 4.46921 7.93484Z" fill="#00ACE6"/>
                        </svg>
                        читати
                    </div>
                    <div class="send" @click="openLanguagePopup('send2')">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.0315 9.02942L17.0622 8.99573L17.0315 8.96204L9.7397 0.966308L9.65276 0.87097V1V5.73955H8.85571C6.74419 5.73955 4.75869 6.56196 3.26555 8.0551C1.77241 9.54824 0.95 11.5337 0.95 13.6454V17V17.129L1.03693 17.0337L2.43635 15.5004C4.28757 13.4722 6.91073 12.2937 9.65276 12.253V16.9916V17.1206L9.7397 17.0253L17.0315 9.02942ZM15.658 8.99573L10.6903 14.443V11.2644V11.2144H10.6403H9.79907C6.86704 11.2144 4.04602 12.3946 1.98762 14.4673V13.6454C1.98762 11.8107 2.70196 10.086 3.99922 8.78877C5.29649 7.49151 7.02107 6.77717 8.85571 6.77717H10.6403H10.6903V6.72717V3.54858L15.658 8.99573Z" fill="#00ACE6" stroke="#00ACE6" stroke-width="0.1"/>
                        </svg>
                        надіслати
                    </div>
                </div>
                <div class="download" @click="openLanguagePopup('download')">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 12.4436H12" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                        <path d="M6.46484 8.08519V1" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                        <path d="M9.68072 5.66956L6.46463 8.85293L3.24854 5.66956" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                    </svg>
                    завантажити
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import ProductPopup from '../library-items/popups/product-popup';
import LanguagePopup from '../library-items/popups/language-popup';

export default {
    props : ['articleItem'],
    components : {
        'product-popup' : ProductPopup,
        'language-popup' : LanguagePopup
    },
    data : () => ({
        isAnotationOpen : false,
        isKeyWordsOpen : false,
        isProductsOpen : false,
        isAlgorithmsOpen : false,

        isProductInfoOpen : false,
        action : '',

        productInfo : {},
        productTestInfo : {
            name : 'Суміш суха Nutrilon Пепті',
            description : 'комплексне рішення при харчовій алергії на білок коров’ячого молока',
            useFor : 'Алергія на БКМ',
            image : ''
        },
    }),
    created(){
        this.articleItem.products.sort((a, b) => {
            if(a.position < b.position) { return -1; }
            if(a.position > b.position) { return 1; }
            return 0;
        })
    },
    methods : {
        getLangCount(){
            let count = 0;
            count = this.articleItem.contentUa || this.articleItem.linkUa ? count + 1 : count;
            count = this.articleItem.contentRu || this.articleItem.linkRu ? count + 1 : count;
            count = this.articleItem.contentEn || this.articleItem.linkEn ? count + 1 : count;

            return count;
        },
        getSingleContent(){
            if(this.articleItem.contentUa)
                return this.articleItem.contentUa;
            if(this.articleItem.contentRu)
                return this.articleItem.contentRu;
            if(this.articleItem.contentEn)
                return this.articleItem.contentEn;
        },
        getProductTags(){
            let tags = [];

            for(let i = 0; i < this.articleItem.products.length; i++){
                tags = tags.concat(this.articleItem.products[i].tags)
            }

            return tags;
        },
        getRef(str){
            return str.substring(6);
        },
        openProductInfoPopup(product){
            this.removeScroll();

            this.productInfo = product;

            this.isProductInfoOpen = true;
        },
         openLanguagePopup(action){
            let langCount = this.getLangCount();
            if(langCount > 1){
                this.action = action;
                this.removeScroll();
            }
            else{
                let content = this.getSingleContent();
                switch(action){
                    case 'read' : {
                        let a  = document.createElement('a');
                        a.href = this.$root.globalUrl + content.name;
                        a.target = "_blank";
                        a.click();
                    }
                    break;
                    case 'download' : {
                        let a  = document.createElement('a');
                        a.href = this.$root.globalUrl + content.name;
                        a.setAttribute('download', "download");
                        a.click();
                    }
                    break;
                    case 'send2' : {
                        document
                            .getElementById("viber_share")
                            .setAttribute(
                                "href",
                                "https://3p3x.adj.st/?adjust_t=u783g1_kw9yml&adjust_fallback=https%3A%2F%2Fwww.viber.com%2F%3Futm_source%3DPartner%26utm_medium%3DSharebutton%26utm_campaign%3DDefualt&adjust_campaign=Sharebutton&adjust_deeplink=" +
                                encodeURIComponent(
                                    "viber://forward?text=" +
                                    encodeURIComponent(this.$root.globalUrl + content.name)
                                )
                            );
                        document.getElementById("viber_share").click();
                    }
                    break;
                }
            }
        },
        closePopup(){
            this.isProductInfoOpen = false;
            this.action = '';
            this.addScroll();
        },
        removeScroll(){
            if(window.screen.width > 426){
                document.getElementsByTagName("body")[0].style.overflow = "visible";
            }
            else{
                document.getElementsByTagName("body")[0].style.overflow = "hidden";
            }
        },
        addScroll(){
            document.getElementsByTagName("body")[0].style.overflow = "visible";
        }
    }
}
</script>

<style lang="scss" scoped>
.scientific-article{
    padding: 15px 15px 60px;
    border-radius: 4px;

    .article-header{
        background: #D5EAF8;
        padding: 10px 15px 15px 15px;

        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .article-type{
            font-size: 12px;
            color: #1E3B89;
        }

        .language{
            display: flex;
            flex-direction: row;

            font-weight: 600;
            font-size: 12px;
            color: #00ACE6;

            .delimetr{
                padding: 0 5px;
            }
        }
    }

    .article-content{
        background: #FFFFFF;

        .article-title{
            padding: 20px 15px;

            display: flex;
            flex-direction: row;

            align-items: center;

            border-bottom: 1px solid #DAE3ED;

            .image{
                padding-right: 14px;
            }

            .title{
                font-weight: 600;
                font-size: 13px;
                line-height: 130%;
                color: #1E3B89;
            }
        }

        .moz-section{
            padding: 13px 18px 5px;
            border-bottom: 1px solid #DAE3ED;

            .row{
                padding-bottom: 13px;

                display: flex;
                flex-direction: row;
                align-items: center;

                font-size: 10px;
                line-height: 14px;
                color: #1E3B89;

                svg{
                    margin-right: 9px;
                }
            }
        }

        .points{
            .item{
                padding: 13px 20px 17px 15px;
                cursor: pointer;
                border-bottom: 1px solid #DAE3ED;

                .title{
                    font-weight: 600;
                    font-size: 14px;
                    color: #1E3B89;

                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;

                    .open{
                        width: 20px;
                        height: 20px;

                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;

                        .line{
                            width: 100%;
                            height: 2px;
                            background: #00ACE6;

                            position: absolute;
                            transition: transform 500ms ease;
                        }

                        .rotated{
                            transform: rotate(-90deg);
                            transition: transform 500ms ease;
                        }
                    }
                }

                .container{
                    padding-top: 10px;

                    font-size: 12px;
                    color: #1E3B89;
                    font-weight: 300;
                    line-height: 135%;
                }

            }

            .key-words, .products{
                .container{
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                }
            }

            .products{
                .container{
                    padding-top: 20px;

                    .product-label{
                        display: flex;

                        margin-right: 10px;
                        margin-bottom: 10px;

                        padding: 4px 4px;
                        border: 0.606867px solid #1E3B89;
                        box-sizing: border-box;
                        border-radius: 4px;
                    }
                }
            }

            .dev-algorithms{
                .container{
                    padding-top: 20px;

                    .algorithm{
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        margin-bottom: 20px;

                        .icon{
                            flex-grow: 1;
                            max-width: 30px;

                            img{
                                width: 100%;
                                height: auto;
                            }
                        }

                        .name{
                            font-size: 13px;
                            color: #1E3B89;

                            padding-left: 10px;
                            padding-right: 10px;

                            flex-grow: 10;

                            width: 50%;
                        }

                        .go{
                            flex-grow: 1;
                            padding: 10px 20px;

                            color: #00ACE6;
                            text-transform: uppercase;
                            font-weight: bold;
                            font-size: 13px;
                            cursor: pointer;
                            border: 1px solid #00ACE6;
                            box-sizing: border-box;
                            border-radius: 4px;
                        }
                    }
                }
            }
        }

        .actions-block{
            padding: 30px 15px;

            .read-send{
                display: flex;
                flex-direction: row;
                padding-bottom: 19px;

                .read, .send{
                    flex-grow: 1;
                    flex-basis: 0;

                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;

                    padding: 11px 0;

                    border: 1px solid #00ACE6;
                    box-sizing: border-box;
                    border-radius: 4px;

                    color: #00ACE6;
                    text-transform: uppercase;
                    font-weight: bold;
                    font-size: 13px;
                    cursor: pointer;

                    svg{
                        margin-right: 9px;
                    }
                }

                .read{
                    margin-right: 10px;
                }
            }

            .download{
                padding: 10px 0;
                background: #00ACE6;
                border-radius: 4px;
                text-align: center;
                font-weight: bold;
                font-size: 15px;
                line-height: 20px;
                text-transform: uppercase;
                color: #FFFFFF;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;

                svg{
                    margin-right: 10px;
                }
            }
        }
    }


}
</style>
